import { Instance, types } from 'mobx-state-tree';

const Flags = types.model({
  isSubmitting: false,
  isFetching: false,
});

export interface IFlags extends Instance<typeof Flags> {}
export default Flags;
